import React from 'react';
import { Nav } from 'shards-react';

export default () => <Nav navbar className="border-left flex-row" />;
